export const environment = {
  production: false,
  apiUrl: 'https://kedana-api-764812137437.me-central2.run.app/'
};
